module.exports = __webpack_public_path__ + "static/media/luisRojas.3d175993.jpg";